const MEDIA_ITEMS = [
  {
    title: '《我独自升级》完结篇深度解析',
    duration: '15:24',
    views: '12.8万',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20review%20video%20thumbnail%20style%20with%20shadow%20warrior%20theme%2C%20dramatic%20dark%20fantasy%20visual%2C%20cinematic%20lighting%2C%20warm%20coral%20accent%2C%20digital%20art%2C%20no%20text%2C%20clean%20composition&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    title: '2024韩国漫画大赏获奖作品速览',
    duration: '08:56',
    views: '9.5万',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20award%20show%20inspired%20visual%20with%20golden%20trophy%20and%20spotlight%20elements%2C%20prestigious%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20digital%20art%2C%20no%20text%2C%20elegant%20design&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    title: '新人漫画家专访：从零到连载',
    duration: '22:10',
    views: '6.3万',
    image: 'https://readdy.ai/api/search-image?query=Artist%20studio%20inspired%20Korean%20manhwa%20style%20visual%20with%20drawing%20tablet%20and%20warm%20lighting%2C%20creative%20atmosphere%2C%20coral%20and%20cream%20tones%2C%20digital%20art%2C%20no%20text%2C%20clean%20composition&width=640&height=360&seq=media-03&orientation=landscape',
  },
  {
    title: '韩国漫画改编韩剧盘点TOP10',
    duration: '18:42',
    views: '15.1万',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20and%20webtoon%20crossover%20visual%20with%20split%20screen%20composition%2C%20warm%20cinematic%20lighting%2C%20coral%20and%20amber%20accents%2C%20digital%20art%2C%20no%20text%2C%20modern%20style&width=640&height=360&seq=media-04&orientation=landscape',
  },
  {
    title: '奇幻题材创作幕后特辑',
    duration: '25:08',
    views: '4.7万',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20world%20building%20Korean%20manhwa%20style%20visual%20with%20magical%20elements%20and%20concept%20art%20feel%2C%20ethereal%20lighting%2C%20warm%20coral%20gradients%2C%20digital%20art%2C%20no%20text%2C%20clean%20design&width=640&height=360&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          精彩视频
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          韩国漫画相关视频内容，深度解读与精彩盘点
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {MEDIA_ITEMS.map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-transform duration-300"
            >
              <div className="relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-video object-cover"
                />
                <div className="absolute inset-0 bg-foreground-900/20 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-900/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1 line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span><i className="ri-eye-line mr-1"></i>{item.views}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}